import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './ScoutSelector.css';
import Input from '../../UI/Input/Input';


class ScoutWithApprovalsSelector extends Component {
    state = {
        scoutUserId: 0,
        scoutSelected: false
    }

    componentDidUpdate(prevProps) {
        if (this.props.scouts.length === 1) {
            this.props.onDataChanged(this.props.scouts[0].UserId);     
        }
    }

    shouldComponentUpdate =(nextProps,nextState) => {
       return true;
    }

    scoutSelected = ( event ) => {
        this.props.onDataChanged(event.target.value);   
        this.setState({scoutUserId:event.target.value});    
    }

    render () {
        if (this.props.scouts) {
            let option = [,];
            option.push({
                value: '0',
                displayValue: 'Select Scout'
            });
            for (let key in this.props.scouts) {
                option.push({
                    value: this.props.scouts[key].UserId,
                    displayValue: this.props.scouts[key].Scout
                });
            }

            const options = {options: option};
            return (
                <div className={classes.ScoutSelector}>
                    <Input value={this.props.scoutUserId} label='Scout' elementType='select' elementConfig={options} changed={(event) => this.scoutSelected(event)}></Input>
                </div>
            );
        }
        else {
            return (
                <div className={classes.ScoutSelector}>
                    There are currently no orders requiring approval.   
                </div>
            );
        }
    }
};

const mapStateToProps = state => {
 
    return {
        scouts: state.orders.scoutsWithApprovals
    };
}


export default connect(mapStateToProps)(ScoutWithApprovalsSelector);


// WEBPACK FOOTER //
// ./src/components/Order/ScoutSelector/ScoutsWithApprovalsSelector.js